import { ApplicationState } from '..';
import {
    MergeFieldsActionTypes,
    MergeFieldsLoadStartAction,
    MergeFieldsLoadSuccessAction,
    MergeFieldsLoadErrorAction,
    MergeFieldsState
} from './types';


export const MergeFieldsLoadStart = (): MergeFieldsLoadStartAction => ({
    type: MergeFieldsActionTypes.LOAD_START,
});

export const MergeFieldsLoadSuccess = (
    data: Record<any,any>
): MergeFieldsLoadSuccessAction => ({
    type: MergeFieldsActionTypes.LOAD_SUCCESS,
    payload: { data },
});

export const MergeFieldsLoadError = (): MergeFieldsLoadErrorAction => ({
    type: MergeFieldsActionTypes.LOAD_ERROR,
});

export const getMergeFieldsStore = (store: ApplicationState): MergeFieldsState => store.mergeFields;
